import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue'
import AuthStore from "@/store/AuthStore"
import PublicLayout from "@/layout/PublicLayout.vue"
import DefaultLayout from "@/layout/DefaultLayout.vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const component = computed(() => {
  return AuthStore.module.isAuthorized ? DefaultLayout : PublicLayout
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(component.value), null, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }))
}
}

})